import React from 'react'
import { Box, Stack } from '@chakra-ui/react'

interface PropsType {
  children: React.ReactNode
  gap?: any
}

const BodyLayout = ({ children, gap }: PropsType) => {
  return (
    <Box mb={28} mt={14}>
      <Stack gap={gap}>{children}</Stack>
    </Box>
  )
}

export default BodyLayout
